import DialogBox, { DialogBoxProps } from './DialogBox';

export default DialogBox;
export type { DialogBoxProps };
